<div class="more-content">
  <button mat-menu-item i18n="@@download" (click)="download()">
    <img src="assets/images/dam/dowload.svg" alt="">
    Скачать
  </button>
  <button mat-menu-item i18n="@@copylink" (click)="copyLink()">
    <img src="assets/images/dam/copy-outline.svg" alt="" style="width:20px">
    Скопировать ссылку
  </button>
  <button mat-menu-item i18n="@@Edit" (click)="previewImage()" *ngIf="data.isImage === true">
    <img src="assets/images/dam/eye-outline.svg" alt="" style="width:20px">
    Предпросмотр изображения
  </button>
  <button mat-menu-item i18n="@@Edit" (click)="previewVideo()" *ngIf="data.isVideo === true">
    <img src="assets/images/dam/eye-outline.svg" alt="" style="width:20px">
    Предпросмотр видео
  </button>
  <button mat-menu-item i18n="@@Edit" (click)="previewText()" *ngIf="data.isText === true">
    <img src="assets/images/dam/eye-outline.svg" alt="" style="width:20px">
    Предпросмотр текста
  </button>
  <button mat-menu-item  (click)="showInfo()">
    <img src="assets/images/dam/postpone.svg" alt="">
    Показать информацию
  </button>

  <button mat-menu-item i18n="@@Edit" (click)="edit()">
    <nb-icon icon="edit-outline"/>
    Изменить
  </button>
  <button mat-menu-item i18n="@@Delete" (click)="openDeletePopup()">
    <nb-icon icon="trash-outline"></nb-icon>
    Удалить
  </button>
</div>
